module.exports = __webpack_public_path__ + "img/Katarina_acc_01.5dbb5546.jpg";